import { useGetUserPermissionsQuery, PermissionKey } from '@client/api';

export function useUserPermission() {
  const { data, error, isError, isLoading } = useGetUserPermissionsQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });

  return {
    data,
    error,
    isError,
    isLoading,
    role: data?.role,
    hasPermission: (permissions: PermissionKey[]) => {
      if (!data?.permissions?.length) return false;
      return permissions.every((permission) => data.permissions.includes(permission));
    },
    hasAnyPermission: (permissions: PermissionKey[]) => {
      if (!data?.permissions?.length) return false;
      return permissions.some((permission) => data.permissions.includes(permission));
    },
  };
}
